import { render, staticRenderFns } from "./OrdenPago.vue?vue&type=template&id=ab975e50&"
import script from "./OrdenPago.vue?vue&type=script&lang=js&"
export * from "./OrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports